(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.collection-faq-section__list').forEach((list) => {
      if (list.dataset.oneAtATime !== 'true') return;
      const items = Array.from(list.querySelectorAll('details'));
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const form = document.getElementById('ContactNewsletter-{{ section.id }}');
    const emailInput = document.getElementById('NewsletterEmail-{{ section.id }}');
    const consentCheckbox = document.getElementById('NewsletterConsent-{{ section.id }}');
    const errorDiv = document.getElementById('ContactNewsletter-errors-{{ section.id }}');
    const successDiv = document.getElementById('ContactNewsletter-success-{{ section.id }}');
    const captchaContainer = document.getElementById('hcaptcha-container-{{ section.id }}');
    const captchaTokenInput = document.getElementById('hcaptcha-token-{{ section.id }}');
    
    if (!form) return;
    
    // Variável para armazenar o widget do hCaptcha
    let hcaptchaWidgetId = null;
    let hcaptchaLoaded = false;
    
    // Detectar site key do hCaptcha da Shopify
    function detectShopifyHCaptchaSiteKey() {
      // Tenta encontrar a site key em scripts existentes
      const scripts = document.querySelectorAll('script[src*="hcaptcha"]');
      for (const script of scripts) {
        const src = script.getAttribute('src');
        const match = src.match(/sitekey=([^&]+)/);
        if (match) {
          return decodeURIComponent(match[1]);
        }
      }
      
      // Tenta encontrar em elementos h-captcha existentes
      const existingCaptcha = document.querySelector('[data-sitekey]');
      if (existingCaptcha) {
        return existingCaptcha.getAttribute('data-sitekey');
      }
      
      // Tenta encontrar em window.hcaptcha se já estiver carregado
      if (window.hcaptcha && window.hcaptcha.sitekey) {
        return window.hcaptcha.sitekey;
      }
      
      // Retorna null se não encontrar (será necessário configurar manualmente)
      return null;
    }
    
    // Carregar script do hCaptcha
    function loadHCaptcha() {
      if (hcaptchaLoaded) return;
      
      // Tenta detectar a site key da Shopify
      let siteKey = detectShopifyHCaptchaSiteKey();
      
      // Se não encontrar, tenta usar uma site key padrão ou desabilita o captcha inline
      if (!siteKey) {
        // Se não houver site key, não carrega o captcha inline
        // O formulário usará o sistema nativo da Shopify
        console.warn('Site key do hCaptcha não detectada. O captcha será gerenciado pela Shopify.');
        return;
      }
      
      // Verifica se o script já está carregado
      if (window.hcaptcha) {
        renderHCaptcha(siteKey);
        return;
      }
      
      const script = document.createElement('script');
      script.src = 'https://js.hcaptcha.com/1/api.js?onload=onHCaptchaLoad&render=explicit';
      script.async = true;
      script.defer = true;
      
      // Callback global para quando o hCaptcha carregar
      window.onHCaptchaLoad = function() {
        hcaptchaLoaded = true;
        renderHCaptcha(siteKey);
      };
      
      document.head.appendChild(script);
    }
    
    // Renderizar o widget do hCaptcha
    function renderHCaptcha(siteKey) {
      if (captchaContainer && window.hcaptcha && siteKey) {
        try {
          hcaptchaWidgetId = window.hcaptcha.render(captchaContainer, {
            sitekey: siteKey,
            size: 'normal',
            theme: 'light',
            callback: function(token) {
              if (captchaTokenInput) {
                captchaTokenInput.value = token;
              }
            },
            'error-callback': function() {
              if (captchaTokenInput) {
                captchaTokenInput.value = '';
              }
            },
            'expired-callback': function() {
              if (captchaTokenInput) {
                captchaTokenInput.value = '';
              }
            }
          });
        } catch (error) {
          console.error('Erro ao renderizar hCaptcha:', error);
        }
      }
    }
    
    // Carregar hCaptcha quando o DOM estiver pronto
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadHCaptcha);
    } else {
      loadHCaptcha();
    }
    
    // Limpar erro quando o checkbox for marcado
    if (consentCheckbox) {
      consentCheckbox.addEventListener('change', function() {
        if (this.checked) {
          this.classList.remove('error');
          if (errorDiv) {
            errorDiv.style.display = 'none';
          }
        }
      });
    }
    
    form.addEventListener('submit', async function(e) {
      const email = emailInput.value.trim();
      
      // Validação básica de e-mail
      if (!email || !email.includes('@')) {
        e.preventDefault();
        showError('Por favor, insira um e-mail válido.');
        return;
      }
      
      // Validação do checkbox de consentimento
      if (!consentCheckbox || !consentCheckbox.checked) {
        e.preventDefault();
        showError('Por favor, aceite os termos para continuar.');
        if (consentCheckbox) {
          consentCheckbox.classList.add('error');
          consentCheckbox.focus();
        }
        return;
      }
      
      // Validação do captcha (apenas se o captcha inline estiver disponível)
      const hasInlineCaptcha = captchaContainer && captchaContainer.querySelector('.h-captcha');
      if (hasInlineCaptcha) {
        if (!captchaTokenInput || !captchaTokenInput.value) {
          e.preventDefault();
          showError('Por favor, complete o desafio de segurança antes de continuar.');
          captchaContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
      }
      
      // Remove erro do checkbox se estiver marcado
      if (consentCheckbox) {
        consentCheckbox.classList.remove('error');
      }
      
      // Se o captcha inline estiver disponível e resolvido, usar fetch para evitar redirecionamento
      if (hasInlineCaptcha && captchaTokenInput && captchaTokenInput.value) {
        e.preventDefault();
        
        // Desabilita o botão durante o envio
        const submitButton = form.querySelector('button[type="submit"]');
        const originalButtonText = submitButton.textContent;
        submitButton.disabled = true;
        submitButton.textContent = 'Enviando...';
        
        // Esconde mensagens anteriores
        errorDiv.style.display = 'none';
        successDiv.style.display = 'none';
        
        try {
          // Cria FormData
          const formData = new FormData();
          formData.append('form_type', 'customer');
          formData.append('utf8', '✓');
          formData.append('contact[tags]', 'newsletter');
          formData.append('contact[email]', email);
          formData.append('h-captcha-response', captchaTokenInput.value);
          
          // Envia via fetch
          const response = await fetch('/contact', {
            method: 'POST',
            body: formData,
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          });
          
          // Verifica se foi redirecionado (sucesso) ou se há erro
          if (response.ok || response.redirected) {
            showSuccess();
            form.reset();
            
            // Resetar captcha após sucesso
            if (hcaptchaWidgetId !== null && window.hcaptcha) {
              try {
                window.hcaptcha.reset(hcaptchaWidgetId);
                if (captchaTokenInput) {
                  captchaTokenInput.value = '';
                }
              } catch (error) {
                console.error('Erro ao resetar captcha:', error);
              }
            }
          } else {
            const text = await response.text();
            // Tenta extrair mensagem de erro se houver
            showError('Ocorreu um erro ao cadastrar. Por favor, tente novamente.');
          }
        } catch (error) {
          console.error('Erro ao enviar newsletter:', error);
          showError('Ocorreu um erro ao cadastrar. Por favor, tente novamente.');
        } finally {
          submitButton.disabled = false;
          submitButton.textContent = originalButtonText;
        }
      }
      // Se não houver captcha inline, deixa o formulário ser enviado normalmente
      // A Shopify gerenciará o captcha automaticamente
    });
    
    function showError(message) {
      errorDiv.textContent = message;
      errorDiv.style.display = 'block';
      emailInput.classList.add('input--error');
      emailInput.focus();
    }
    
    function showSuccess() {
      successDiv.style.display = 'block';
      emailInput.classList.remove('input--error');
      errorDiv.style.display = 'none';
    }

    // Observer para modificar CSS da classe dentro do Shadow DOM
    let shadowDOMObserver = null;
    let appliedStyles = new WeakSet();

    // Função para aplicar estilos no elemento encontrado
    function applyStyles(element) {
      if (!element || appliedStyles.has(element)) return;
      
      // Aplica display flex para exibir itens lado a lado
      element.style.display = 'flex';
      element.style.flexDirection = 'row';
      element.style.gap = '0.5rem';
      element.style.alignItems = 'center';
      
      // Encontra o botão dentro do fieldset
      const button = element.querySelector('button');
      if (button) {
        button.style.width = 'fit-content';
        button.style.padding = '0.75rem 1.5rem';
        button.style.flexShrink = '0';
      }
      
      // Encontra o input dentro do fieldset
      const input = element.querySelector('input[type="email"], input[type="text"]');
      if (input) {
        input.style.minWidth = '260px';
        input.style.width = 'auto';
        input.style.flex = '1';
      }
      
      // Marca como processado
      appliedStyles.add(element);
    }

    // Função para buscar e aplicar estilos em Shadow DOMs
    function applyShadowDOMStyles() {
      // Busca diretamente no documento primeiro (caso não esteja em Shadow DOM)
      const directFieldset = document.querySelector('._formFieldset_cit2d_82');
      if (directFieldset) {
        applyStyles(directFieldset);
        return true;
      }

      // Busca especificamente no elemento shopify-forms-embed
      const shopifyFormsEmbed = document.querySelector('shopify-forms-embed');
      if (shopifyFormsEmbed) {
        // Tenta acessar o Shadow DOM
        if (shopifyFormsEmbed.shadowRoot) {
          const fieldset = shopifyFormsEmbed.shadowRoot.querySelector('._formFieldset_cit2d_82');
          if (fieldset) {
            applyStyles(fieldset);
            return true;
          }
        }
      }

      // Busca por todos os elementos na página que podem ter Shadow DOM
      const allElements = document.querySelectorAll('*');
      let found = false;
      
      allElements.forEach(el => {
        // Verifica se o elemento tem Shadow DOM
        if (el.shadowRoot) {
          const fieldset = el.shadowRoot.querySelector('._formFieldset_cit2d_82');
          if (fieldset) {
            applyStyles(fieldset);
            found = true;
          }
          
          // Busca recursivamente dentro do Shadow DOM por outros Shadow DOMs
          const shadowChildren = el.shadowRoot.querySelectorAll('*');
          shadowChildren.forEach(shadowChild => {
            if (shadowChild.shadowRoot) {
              const nestedFieldset = shadowChild.shadowRoot.querySelector('._formFieldset_cit2d_82');
              if (nestedFieldset) {
                applyStyles(nestedFieldset);
                found = true;
              }
            }
          });
        }
      });
      
      return found;
    }

    // MutationObserver para detectar quando o Shadow DOM é criado
    function initShadowDOMObserver() {
      // Cria o observer
      shadowDOMObserver = new MutationObserver(function(mutations) {
        let shouldCheck = false;
        
        mutations.forEach(mutation => {
          // Verifica se novos nós foram adicionados
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { // Element node
              // Verifica se é o elemento shopify-forms-embed
              if (node.tagName === 'SHOPIFY-FORMS-EMBED' || 
                  node.querySelector && node.querySelector('shopify-forms-embed')) {
                shouldCheck = true;
              }
              // Verifica se algum elemento com Shadow DOM foi adicionado
              if (node.shadowRoot) {
                shouldCheck = true;
              }
            }
          });
        });
        
        if (shouldCheck) {
          // Usa requestAnimationFrame para evitar múltiplas execuções
          requestAnimationFrame(() => {
            applyShadowDOMStyles();
          });
        }
      });

      // Observa mudanças no DOM
      if (document.body) {
        shadowDOMObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }

      // Observer específico para quando o Shadow DOM do shopify-forms-embed for criado
      let pollingInterval = null;
      
      function observeShopifyFormsEmbed() {
        // Tenta aplicar estilos imediatamente
        if (applyShadowDOMStyles()) {
          return true;
        }
        
        // Se não encontrou, inicia polling
        if (!pollingInterval) {
          let attempts = 0;
          const maxAttempts = 100; // 10 segundos máximo
          
          pollingInterval = setInterval(() => {
            attempts++;
            if (applyShadowDOMStyles()) {
              clearInterval(pollingInterval);
              pollingInterval = null;
            } else if (attempts >= maxAttempts) {
              clearInterval(pollingInterval);
              pollingInterval = null;
            }
          }, 100);
        }
        
        return false;
      }

      // Executa imediatamente após um pequeno delay para garantir que o DOM está pronto
      setTimeout(() => {
        applyShadowDOMStyles();
        observeShopifyFormsEmbed();
      }, 100);

      // Executa novamente após um delay maior para capturar elementos carregados dinamicamente
      setTimeout(() => {
        applyShadowDOMStyles();
        observeShopifyFormsEmbed();
      }, 1000);

      // Executa quando a página estiver totalmente carregada
      if (document.readyState === 'complete') {
        setTimeout(() => {
          applyShadowDOMStyles();
          observeShopifyFormsEmbed();
        }, 100);
      } else {
        window.addEventListener('load', () => {
          setTimeout(() => {
            applyShadowDOMStyles();
            observeShopifyFormsEmbed();
          }, 500);
        });
      }
    }

    // Inicializa o observer quando o DOM estiver pronto
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initShadowDOMObserver);
    } else {
      initShadowDOMObserver();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const shareButton = document.querySelector('.btn--share');
    
    if (shareButton) {
      shareButton.addEventListener('click', function() {
        if (navigator.share) {
          navigator.share({
            title: document.title,
            url: window.location.href
          }).catch(function(err) {
            console.log('Error sharing:', err);
            fallbackShare();
          });
        } else {
          fallbackShare();
        }
      });
    }

    function fallbackShare() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(window.location.href).then(function() {
          alert('Link copiado para a área de transferência!');
        }).catch(function(err) {
          console.log('Error copying:', err);
        });
      } else {
        // Fallback mais antigo
        const textArea = document.createElement('textarea');
        textArea.value = window.location.href;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          alert('Link copiado para a área de transferência!');
        } catch (err) {
          console.log('Error copying:', err);
        }
        document.body.removeChild(textArea);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Variant picker functionality
    const variantPickers = document.querySelectorAll('.variant-picker-with-images');
    
    variantPickers.forEach(picker => {
      const inputs = picker.querySelectorAll('input[type="radio"]');
      
      inputs.forEach(input => {
        input.addEventListener('change', function() {
          updateProductData(this);
        });
      });
    });
    
    function updateProductData(selectedInput) {
      const variantId = selectedInput.value;
      const productHandle = selectedInput.closest('.variant-picker-with-images').dataset.productId;
      
      fetch(`/products/${productHandle}.js`)
        .then(response => response.json())
        .then(product => {
          const variant = product.variants.find(v => v.id == variantId);
          if (variant) {
            updatePrice(variant);
            updateAddToCartForm(variant);
            updateImages(variant);
          }
        })
        .catch(error => console.error('Erro ao buscar dados do produto:', error));
    }
    
    function updatePrice(variant) {
      const priceElement = document.querySelector('.price-current .price-amount');
      if (priceElement) {
        priceElement.textContent = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).format(variant.price / 100);
      }
      
      const installmentElement = document.querySelector('.installments span:last-child');
      if (installmentElement) {
        const installmentPrice = variant.price / 4;
        installmentElement.textContent = `4x de ${new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).format(installmentPrice / 100)} sem juros`;
      }
    }
    
    function updateAddToCartForm(variant) {
      const forms = document.querySelectorAll('.product-form');
      forms.forEach(form => {
        const hiddenInput = form.querySelector('input[name="id"]');
        if (hiddenInput) {
          hiddenInput.value = variant.id;
        }
      });
    }
    
    function updateImages(variant) {
      if (variant.featured_image) {
        const galleryItems = document.querySelectorAll('.product-gallery__item img');
        if (galleryItems.length > 0) {
          galleryItems[0].src = variant.featured_image.src;
          galleryItems[0].alt = variant.featured_image.alt;
        }
      }
    }
    
    // Image gallery zoom functionality
    const galleryItems = document.querySelectorAll('.product-gallery__item');
    galleryItems.forEach(item => {
      item.addEventListener('click', function() {
        const img = this.querySelector('img');
        if (img) {
          // Simple zoom implementation - can be enhanced with a modal
          img.style.transform = img.style.transform === 'scale(1.5)' ? 'scale(1)' : 'scale(1.5)';
          img.style.transition = 'transform 0.3s ease';
        }
      });
    });
    
    // Description toggle functionality
    const descriptionToggle = document.querySelector('.product-description__toggle');
    if (descriptionToggle) {
      descriptionToggle.addEventListener('click', function(e) {
        e.preventDefault();
        const content = document.querySelector('.product-description__content');
        if (content) {
          content.style.maxHeight = content.style.maxHeight ? 'none' : '100px';
          content.style.overflow = content.style.overflow ? 'visible' : 'hidden';
          this.textContent = this.textContent === '+ Ver mais' ? '- Ver menos' : '+ Ver mais';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-custom"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const grid = document.getElementById('recommendations-grid');
    const dotsContainer = document.getElementById('recommendations-dots');
    const prevBtn = document.getElementById('recommendations-prev-btn');
    const nextBtn = document.getElementById('recommendations-next-btn');
    
    if (!grid || !dotsContainer || !prevBtn || !nextBtn) return;
    
    let currentPage = 0;
    let itemsPerPage = 4;
    let totalPages = 0;
    
    // Calcular total de páginas
    function updatePagination() {
      const cards = grid.querySelectorAll('.product-card');
      totalPages = Math.ceil(cards.length / itemsPerPage);
      updateDots();
      updateButtons();
    }
    
    // Atualizar dots
    function updateDots() {
      dotsContainer.innerHTML = '';
      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('div');
        dot.className = `product-recommendations__dot ${i === currentPage ? 'product-recommendations__dot--active' : ''}`;
        dot.addEventListener('click', () => goToPage(i));
        dotsContainer.appendChild(dot);
      }
    }
    
    // Atualizar botões
    function updateButtons() {
      prevBtn.disabled = currentPage === 0;
      nextBtn.disabled = currentPage === totalPages - 1;
    }
    
    // Ir para página específica
    function goToPage(page) {
      currentPage = page;
      const scrollLeft = page * (grid.offsetWidth / itemsPerPage);
      grid.scrollTo({ left: scrollLeft, behavior: 'smooth' });
      updateDots();
      updateButtons();
    }
    
    // Navegação
    prevBtn.addEventListener('click', () => {
      if (currentPage > 0) {
        goToPage(currentPage - 1);
      }
    });
    
    nextBtn.addEventListener('click', () => {
      if (currentPage < totalPages - 1) {
        goToPage(currentPage + 1);
      }
    });
    
    // Wishlist
    // O wishlist-manager.js agora cuida de toda a lógica de wishlist
    // Listener removido para evitar conflito
    
    // Responsividade
    function handleResize() {
      if (window.innerWidth <= 768) {
        itemsPerPage = 2;
      } else if (window.innerWidth <= 1200) {
        itemsPerPage = 3;
      } else {
        itemsPerPage = 4;
      }
      updatePagination();
    }
    
    window.addEventListener('resize', handleResize);
    handleResize();
  });

  } catch(e) { console.error(e); }
})();
})();
